import util from '../util';

export const SHOWROOM_LIST = 'SHOWROOM_LIST';
export const RECENT_DEAL_LIST = 'RECENT_DEAL_LIST';
export const ALL_DEALS = 'ALL_DEALS';
export const DEAL = 'DEAL';
export const DEALER = 'DEALER';
export const DEAL_UPDATE = 'DEAL_UPDATE';
export const DEAL_CREATE = 'DEAL_CREATE';
export const DEAL_TRADEINS_UPDATE = 'DEAL_TRADEINS_UPDATE';
export const ONLINE_DEAL_CREATE = 'ONLINE_DEAL_CREATE';
export const PAYMENTS = 'PAYMENTS';
export const SET_DEAL_TRADEINS = 'SET_DEAL_TRADEINS';

export const LOAD_DEAL_DATA = 'LOAD_DEAL_DATA';

export const SHOWROOM_LIST_REQUEST = util.requestType(SHOWROOM_LIST);
export const SHOWROOM_LIST_SUCCESS = util.successType(SHOWROOM_LIST);
export const SHOWROOM_LIST_FAILURE = util.failureType(SHOWROOM_LIST);
export const SHOWROOM_LIST_POLLING_RESET = util.resetType(SHOWROOM_LIST);

export const RECENT_DEAL_LIST_REQUEST = util.requestType(RECENT_DEAL_LIST);
export const RECENT_DEAL_LIST_SUCCESS = util.successType(RECENT_DEAL_LIST);
export const RECENT_DEAL_LIST_FAILURE = util.failureType(RECENT_DEAL_LIST);

export const ALL_DEALS_REQUEST = util.requestType(ALL_DEALS);
export const ALL_DEALS_SUCCESS = util.successType(ALL_DEALS);
export const ALL_DEALS_FAILURE = util.failureType(ALL_DEALS);

export const DEAL_REQUEST = util.requestType(DEAL);
export const DEAL_SUCCESS = util.successType(DEAL);
export const DEAL_FAILURE = util.failureType(DEAL);

export const DEAL_UPDATE_SUCCESS = util.successType(DEAL_UPDATE);
export const DEAL_UPDATE_FAILURE = util.failureType(DEAL_UPDATE);

export const DEAL_TRADEINS_UPDATE_SUCCESS =
  util.successType(DEAL_TRADEINS_UPDATE);
export const DEAL_TRADEINS_UPDATE_FAILURE =
  util.failureType(DEAL_TRADEINS_UPDATE);

export const DEAL_CREATE_REQUEST = util.requestType(DEAL_CREATE);
export const DEAL_CREATE_SUCCESS = util.successType(DEAL_CREATE);
export const DEAL_CREATE_FAILURE = util.failureType(DEAL_CREATE);

export const ONLINE_DEAL_CREATE_REQUEST = util.requestType(ONLINE_DEAL_CREATE);
export const ONLINE_DEAL_CREATE_SUCCESS = util.successType(ONLINE_DEAL_CREATE);
export const ONLINE_DEAL_CREATE_FAILURE = util.failureType(ONLINE_DEAL_CREATE);

export const DEALER_REQUEST = util.requestType(DEALER);
export const DEALER_SUCCESS = util.successType(DEALER);
export const DEALER_FAILURE = util.failureType(DEALER);

export const PAYMENTS_REQUEST = util.requestType(PAYMENTS);
export const PAYMENTS_SUCCESS = util.successType(PAYMENTS);
export const PAYMENTS_FAILURE = util.failureType(PAYMENTS);
export const PAYMENTS_RESET = util.resetType(PAYMENTS);

export const LOAD_DEAL_DATA_REQUEST = util.requestType(LOAD_DEAL_DATA);
